module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAABGUlEQVQokY3SvyvEcRzH8ccdLsMNBgbbZTCeiSxIDOdHCYPxisUfYCeLyazvYKEsDAb5kZKBXJksyCpGSpEiGb7f4+K+37vX9qnX89P7/Xq9U0EQZNCBW3UojWXcYA1N9QCneMc8jtFaCzhEPx4wgEvkkwCRqQcl5HCOqSQAHjGIDWSxg0Wk4gDRLkUs4AtL2I4+qAqUtYoxPGMaZ9GosQAcoVfYT5dwz9kkAO4iaF8Y93otAF5wVX401jA3IMAcPrGSBDRjC5N4wwz24oAW7Aqbf8I4LuJGaheeSx73KOA6bodOYZy5yFSIoB9VptTtt6AS+v6aK4EhnKANBxiOZv+nNEaFxWSxiQm8VjOXgRFkhPdTxEecGb4BWcQ4/8eot5AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_list_grey_rightarrow@2x.png
// module id = 609
// module chunks = 17